module.exports = __webpack_public_path__ + "static/media/drumpad.10b94d27.png";